import { useQuery } from "@tanstack/react-query"
import { Card, Col, Row, Statistic, Spin, Typography } from "antd"
import type React from "react"

const { Title, Text } = Typography
import { IconUsers, IconBook, IconFolder, IconBookmark } from "@tabler/icons-react"
import { dashboardService } from "@/services/dashboard/dashboardApi"

export const DashboardPage: React.FC = () => {
  const { data: result, isFetching } = useQuery({
    queryKey: ["dashboard_stats"],
    queryFn: () => dashboardService.getStats(),
  })

  if (isFetching && !result) {
    return (
      <div className="flex h-[300px] items-center justify-center">
        <Spin size="large" tip="Đang tải dữ liệu thống kê..." />
      </div>
    )
  }

  const stats = result?.data

  const cardConfigs = [
    {
      title: "Tài khoản User",
      value: stats?.users ?? 0,
      icon: <IconUsers size={32} className="text-blue-500" />,
      color: "from-blue-50 to-blue-100/50 border-blue-200",
    },
    {
      title: "Dữ liệu từ điển",
      value: stats?.dictionary?.total ?? 0,
      icon: <IconBook size={32} className="text-emerald-500" />,
      color: "from-emerald-50 to-emerald-100/50 border-emerald-200",
    },
    {
      title: "Sổ từ vựng",
      value: stats?.sets ?? 0,
      icon: <IconFolder size={32} className="text-purple-500" />,
      color: "from-purple-50 to-purple-100/50 border-purple-200",
    },
    {
      title: "Từ vựng đã lưu",
      value: stats?.vocabularies ?? 0,
      icon: <IconBookmark size={32} className="text-orange-500" />,
      color: "from-orange-50 to-orange-100/50 border-orange-200",
    },
  ]

  return (
    <div className="flex flex-col gap-6 p-4">
      <div>
        <Title level={3} className="m-0! tracking-tight">
          Tổng quan hệ thống
        </Title>
        <div className="mt-1">
          <Text type="secondary" className="text-sm">
            Báo cáo số liệu thống kê thời gian thực của Jupi.vn
          </Text>
        </div>
      </div>

      <Row gutter={[16, 16]}>
        {cardConfigs.map((config, index) => (
          <Col key={index} xs={24} sm={12} lg={6}>
            <Card
              bordered
              className={`bg-linear-to-br ${config.color} cursor-pointer border transition-all duration-300 hover:-translate-y-1 hover:shadow-md`}
              classNames={{ body: "p-6" }}
            >
              <div className="flex items-center justify-between">
                <div className="flex flex-col gap-1">
                  <span>
                    <Text type="secondary" className="font-semibold text-sm uppercase tracking-wider">
                      {config.title}
                    </Text>
                  </span>
                  <span className="mt-1 font-extrabold text-3xl">
                    <Statistic
                      value={config.value}
                      groupSeparator=","
                      valueStyle={{ fontSize: "1.875rem", fontWeight: 800 }}
                    />
                  </span>
                </div>
                <div className="rounded-xl border border-gray-100 bg-white p-3 shadow-sm">{config.icon}</div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default DashboardPage
